import { DatabaseTwoTone } from "@ant-design/icons";
import { Breadcrumb, Typography } from "antd";
import "../../styles/breadcrumbFolder.css";

const { Text } = Typography;

interface IProps {
  routes: any[];
  onClick: (path: string) => void;
}

const BreadcrumbFolder = (props: IProps) => {
  const { onClick, routes } = props;

  return (
    <Text
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 5,
      }}
    >
      <DatabaseTwoTone style={{ marginRight: "5px" }} twoToneColor="#c2c3c6" />
      <Breadcrumb
        key={"lllc"}
        style={{ color: "#495057" }}
      >
        {routes.length > 0 ? (
          routes.map((item: any, idx) => {
            return idx === routes.length - 1 ? (
              <Breadcrumb.Item key={idx}>
                <Text>{item.name}</Text>
              </Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item key={idx} onClick={() => onClick(item.path)}>
                <Text style={{ cursor: "pointer" }}>{item.name}</Text>
              </Breadcrumb.Item>
            );
          })
        ) : (
          <></>
        )}
      </Breadcrumb>
    </Text>
  );
};
export default BreadcrumbFolder;
